(() => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');

  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-visible'));
  }

  const sticky = document.querySelector('[data-sticky-atc]');
  const form = document.getElementById('ProductForm');
  const trigger = document.querySelector('[data-sticky-atc-trigger]');
  const addBtn = document.querySelector('[data-add-to-cart]');

  if (sticky && form && addBtn) {
    sticky.hidden = false;
    const syncSticky = () => {
      const rect = addBtn.getBoundingClientRect();
      const shouldShow = rect.bottom < 0;
      sticky.classList.toggle('is-visible', shouldShow);
    };
    window.addEventListener('scroll', syncSticky, { passive: true });
    syncSticky();

    if (trigger) {
      trigger.addEventListener('click', () => {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    }
  }

  const gallery = document.querySelector('[data-product-gallery]');
  if (gallery) {
    const main = gallery.querySelector('[data-gallery-main]');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const fullSrc = thumb.getAttribute('data-full-src');
        if (!main || !fullSrc) return;
        main.src = fullSrc;
        const thumbImg = thumb.querySelector('img');
        if (thumbImg && thumbImg.alt) main.alt = thumbImg.alt;
        thumbs.forEach((t) => {
          t.classList.toggle('is-active', t === thumb);
          t.setAttribute('aria-pressed', t === thumb ? 'true' : 'false');
        });
      });
    });
  }
})();
